import LotteryNumlotDetailContainer from "../../components/lottery/containers/LotteryNumlotDetailContainer";
import LotteryNumlotDetailTemplate from "../../components/lottery/templates/LotteryNumlotDetailTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Loto6() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="lt6" />
      <section className="min-h-screen">
        <LotteryNumlotDetailContainer lotteryKey="lt6" Template={LotteryNumlotDetailTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="lt6" />
    </>
  );
}
export default Loto6;
